/**
 * Servis çalışanı (uygulama kabuğu, telefon bildirimleri, "yeni sürüm hazır" bandı).
 *
 * Uygulama açılır açılmaz, giriş yapılmadan da kaydolur: giriş ve kurulum (/kur) sayfasında telefonun
 * "uygulamayı yükle" önerisi ve çevrimdışı açılış buna bağlıdır. Yeni sürüm kullanıcı onayıyla uygulanır
 * (registerType: prompt); taslaklar IndexedDB'de olduğu için güncelleme taslak kaybettirmez (T25).
 */
import { useSyncExternalStore } from 'react';
import { registerSW } from 'virtual:pwa-register';

let needRefresh = false;
let update: ((reloadPage?: boolean) => Promise<void>) | null = null;
const listeners = new Set<() => void>();

function set(value: boolean) {
  needRefresh = value;
  listeners.forEach((l) => l());
}

export function startServiceWorker(): void {
  if (update || !('serviceWorker' in navigator)) return;
  update = registerSW({
    immediate: true,
    onNeedRefresh: () => set(true),
    // uygulama günlerce açık kalabilir (telefonda arka planda): yeni sürüm saatte bir ve ekrana dönüldüğünde sorulur
    onRegisteredSW: (_url, reg) => {
      if (!reg) return;
      const check = () => { void reg.update().catch(() => undefined); };
      window.setInterval(check, 60 * 60 * 1000);
      document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') check(); });
    },
  });
}

export function useNeedRefresh(): boolean {
  return useSyncExternalStore((l) => { listeners.add(l); return () => { listeners.delete(l); }; }, () => needRefresh);
}

export function applyUpdate(): void {
  void update?.(true);
}

export function dismissUpdate(): void {
  set(false);
}
